import React from 'react'
import CopilotContext from '../../../contexts/CopilotContext'
import StatusContext from '../../../contexts/StatusContext'
import ClientContext from "../../../contexts/ClientContext";
import {ResponseDisplayWithQuestions} from "../responsedisplay/ResponseDisplayWithQuestions"
import "./copilot.css"
import { useLocation } from 'react-router-dom'
import { useEffect } from "react";
import {NavBarCopilot} from '../navbarcopilot/NavBarCopilot'
import {PromptWithIcon} from '../promptwithicon/PromptWithIcon';
import { AlertDialog } from '../alertdialog/AlertDialog'
import {PushButton} from '../pushbutton/PushButton'
import {AvailableCredits} from '../availablecredits/AvailableCredits'
import { useParams } from "react-router-dom"
import {useState} from "react";
import { ProgressIcon } from '../customicons/ProgressIcon';
import { WaitonResponse } from '../waitonresponse/WaitonResponse';
import AIButton from '../aibutton/AIButton';
import Stack from '@mui/material/Stack'
import { DialogSelectModels } from '../aibutton/DialogSelectModels';
import { DialogCopilotProgress } from './DialogCopilotProgress';


export const Copilot = () => {

    const { answer: initialAnswer } = useParams();
    const [answer, setAnswer] = useState(initialAnswer || '');
    

    const alertYes = () => {
        console.log("AlertYes")
        onClearChat()
        setAnswer('');
        closeDialogBox()
    }

    const alertCancel = () => {
        console.log("AlertCancel")
        closeDialogBox()
    }
    
    let {
        promptsandresponses, 
        onClearChat,
        confirmDelete, 
        changeConfirmDelete,
        onDeletePrompt,
        onSubmitQuestion,
        displaySample,
        chatPrompt,
        setChatPrompt,
        onSubmitChat,
        status,
        onClickRelated,
        onResubmitChat,
        SendRequest,
        setShowCopilotProgressDialog,
       
    } = React.useContext(CopilotContext);

    let {
        isLoading,
      
        isMobile,
        scrollRef,
        changeLanguage,
        openDialog,
        openDialogBox,
        closeDialogBox,

        onCopy,

        getAIModel,
        getAIProvider,
        onClickAIButton,
    } = React.useContext(StatusContext);

    const {
        availablecredits,
      
    } = React.useContext(ClientContext);
   

    var  sample ='';


    const location = useLocation()
    if (location.state !== null)
         sample = location.state.sample

    useEffect(() => {

        console.log("useEffect - Copilot: ")

        const setSample = () => {
            
            if (sample)
            {
                displaySample(sample)
                location.state.sample = '';
            }
        }
        setSample();

        let question = localStorage.getItem('CopilotQuestion') || ''

        if (availablecredits && question && question !== '')
        {
            setChatPrompt(question)
            localStorage.setItem("CopilotQuestion", "")
            
            setShowCopilotProgressDialog(true)
            SendRequest(question)
           
        }

    }, [sample, displaySample, location.state, answer, setChatPrompt, SendRequest, setShowCopilotProgressDialog, availablecredits])   
   
    const handleClear = () => {
       
        openDialogBox()

    }
    
  return (

    <div className="homeContainer">
            {
                isMobile() &&
                   <AIButton pane={0} provider = {getAIProvider()} model = {getAIModel()} onClick = {()=>{onClickAIButton(0)}}/>
            }
              
     
                <NavBarCopilot title={changeLanguage('assistant', 'navbartitle_2')}/>
               
                <div className="response-markdown" ref={scrollRef} >
                        
                
                        {
                            Array.isArray(promptsandresponses) &&
                            promptsandresponses.map((item, index) => (
                              
                                    <ResponseDisplayWithQuestions key= {item.id} displayprompt = {item} displayicons = {confirmDelete[promptsandresponses.indexOf(item)].state}
                                        changeConfirmDelete={changeConfirmDelete}
                                        onDeletePrompt={onDeletePrompt}
                                        onSubmitQuestion = {onSubmitQuestion}
                                        onResubmitChat={onResubmitChat}
                                        onClickRelated={onClickRelated}
                                        onCopy={onCopy} />
                             
                                ))
                           
                        }
                  
                 
                </div> 
                <hr className = 'separator'></hr> 
                {
                    (!status) &&
                     <WaitonResponse />
                }

              
                <PromptWithIcon prompt = {chatPrompt} setPrompt={setChatPrompt} onSubmit={onSubmitChat} placeholdertext={changeLanguage('assistant','promptplaceholder')}/>
               

                {
                (status) && <label className = 'statusLabel'>{status}</label>
                }
                
                <div className="mainButtons">
                <Stack direction = "row" spacing={2}>
                    {
                        !isMobile() &&
                            <AIButton pane={0} provider = {getAIProvider()} model = {getAIModel()} onClick = {()=>{onClickAIButton(0)}}/>
                    }
                    <PushButton onClick={handleClear} label =  {changeLanguage('assistant','clearall')}/>
                </Stack>
                    <AvailableCredits />
                </div> 

                <label style={{ width: isMobile() ? '100%' : '50%' }}>{changeLanguage("copilot", "note")}</label>
               
             

                <AlertDialog alertYes={alertYes} alertCancel={alertCancel} openDialog = {openDialog} closeDialog = {closeDialogBox} prompt={changeLanguage('dialog', 'cleardata')}/>
                <ProgressIcon isLoading={isLoading} /> 
                <DialogSelectModels />
                <DialogCopilotProgress />
      
         
     </div>
  )
}


